import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useMaquinasEquipControleFilters
 */

type State = {
  centroCusto: number[] | null;
  status: number | null;
};

type Actions = {
  clear: () => void;
};

export const useMaquinasEquipControleFilters = create<State & Actions>((set) => ({
  centroCusto: null,
  status: 0,
  clear: () => set({ centroCusto: null, status: null }),
}));
